__turbopack_context__.v({
  "avatar": "wBVeNG_avatar",
});
